import * as React from "react";

import { Callout } from "kanopi-components/Callout";
import { Markdown } from "kanopi-components/Markdown";

import { WidthContainer } from "../../ChatFlow/WidthContainer";
import { parseAndPurifyHtml } from "kw/util/utils";

type TCalloutRhetorical = {
  kind: string;
  label: string;
  renderMarkdown?: boolean;
};

export function CalloutRhetorical(props: TCalloutRhetorical) {
  const { label, renderMarkdown = false, ...restProps } = props;
  return (
    <WidthContainer>
      <Callout
        overrides={{
          Body: {
            style: {
              width: "100%",
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 0,
              marginTop: 0,
              marginBottom: 0,
              marginLeft: 0,
              marginRight: 0,
            },
          },
        }}
        {...restProps}
      >
        {renderMarkdown ? <Markdown>{label}</Markdown> : parseAndPurifyHtml(label)}
      </Callout>
    </WidthContainer>
  );
}
